export default {
  bind(el, { value }) {
    el.onClickOutside = e => {
      if (el.contains(e.target)) return
      value()
    }
    document.addEventListener('mousedown', el.onClickOutside)
  },

  unbind(el) {
    document.removeEventListener('mousedown', el.onClickOutside)
  }
}
